import { SET_BUCKET_DOMAIN, SET_BUCKET_DOMAIN_TOKEN } from './mutationTypes';

export default {
  update_operation_list(state, payload) {
    state.operationList = payload;
  },
  update_permission_list(state, payload) {
    state.permissionList = payload;
  },
  updateLoginData(state, payload) {
    state.loginData = payload;
  },
  setBucketDomain(state, payload) {
    state.imgDomain = payload;
  },
  // [SET_BUCKET_DOMAIN](state, payload) {
  //   state.imgDomain = payload;
  // },
  // [SET_BUCKET_DOMAIN_TOKEN](state, payload) {
  //   state.bucket_domain_token = payload;
  // }
};